module.exports = __webpack_public_path__ + "static/media/calender.2fd4d818.svg";